import SvgIcon from '@/pages/home/components/SvgIcon';
import React from 'react';

export function getSentimentItem(type: string, text: string) {
  return (
    <div className="dbo-select-flex">
      <SvgIcon type={type} className="dbo-select-icon" />
      <span>{text}</span>
    </div>
  );
}
export const sentimentOptions = (
  formatMessage: ({ id }: { id: string }) => string,
) => [
  {
    text: getSentimentItem(
      'laugh-green-color',
      formatMessage({ id: 'Positive' }),
    ),
    value: '5',
  },
  {
    text: getSentimentItem(
      'laugh-red-color',
      formatMessage({ id: 'Negative' }),
    ),
    value: '1',
  },
  {
    text: getSentimentItem(
      'laugh-grey-color',
      formatMessage({ id: 'Neutral' }),
    ),
    value: '3',
  },
];
